<template>
  <div class="navbar">
    <div class="app-name">{{ $appName }}</div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/_variables.sass'
.navbar
  background: $color-purple
  color: $color-white
  display: flex
  justify-content: space-between
  align-items: center
  padding: 0.5rem
  font-weight: 700
  font-size: $font-size-large
  @media screen and (max-width: 374px)
    font-size: $font-size-medium

.leave-button
  font-family: $font-family
  font-size: $font-size-small
  letter-spacing: 1px
  display: flex
  align-items: center

  .leave-label
    font-family: $font-family
    padding-right: 0.25rem

  .leave-icon svg
    display: flex
    height: 1.5em
    fill: $color-white
</style>
